// react and js
import { useLocation, useNavigate } from "react-router-dom";
import { React, useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

// mui
import { Grid, Container, Box } from "@mui/material";

// components
import Page from "../../components/Page";
import CardOutlet from "../../components/CardOutlet";

// hooks
import appContext from "../../hooks/appContext";

// layouts

// pages

// theme
import { B1Small } from "../../theme/styled";

// utils

// i18n
import { localizeExternalUrl } from "../../i18n/languages";

// widgets
import WidgetMt5TickData from "../../widgets/downloads/Mt5TickData";

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function Downloads() {
  // eslint-disable-next-line
  const { stateStorage, setStateStorage } = useContext(appContext);
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();

  const websiteDownloadsUrl = localizeExternalUrl(
    `${process.env.REACT_APP_URL_FRONTEND_WEBSITE}/downloads`,
    i18n.language
  );

  // ######################################################
  // Scroll to top on mount
  // ######################################################
  useEffect(() => {
    const autoScrollContainer = document.querySelector(
      "#auto-scroll-container"
    );
    if (autoScrollContainer !== null) {
      autoScrollContainer.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ######################################################
  // Outlet protection
  // ######################################################
  let isOutletAllowed = false;
  if (stateStorage.userInformation !== "") {
    if (
      stateStorage.userInformation.account_settings !== null &&
      stateStorage.userInformation.account_settings !== undefined
    ) {
      if (
        stateStorage.userInformation.account_settings.dashboard_features !==
          null &&
        stateStorage.userInformation.account_settings.dashboard_features !==
          undefined
      ) {
        if (
          stateStorage.userInformation.account_settings.dashboard_features
            .obfs998de9826cbc26b1 !== null &&
          stateStorage.userInformation.account_settings.dashboard_features
            .obfs998de9826cbc26b1 !== undefined
        ) {
          if (
            stateStorage.userInformation.account_settings.dashboard_features
              .obfs998de9826cbc26b1 === "obfs7c64df1a627d2987"
          ) {
            isOutletAllowed = true;
          }
        }
      }
    }
  }

  useEffect(() => {
    if (isOutletAllowed === false) {
      if (location.pathname !== "/") {
        navigate("/");
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateStorage]);

  // ######################################################
  // Main outlet
  // ######################################################

  // eslint-disable-next-line
  return useMemo(() => {
    return isOutletAllowed ? (
      <Page title={t("pages.downloads.title")}>
        <Container maxWidth="false">
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <CardOutlet
                variant="description"
                backgroundProp="#F2F2F2"
                title={t("pages.downloads.application_download.title")}
                subheader={
                  <>
                    {t("pages.downloads.application_download.subheader")}
                    <Box sx={{ mt: 2 }}>
                      <B1Small
                        fullWidth
                        variant="contained"
                        href={websiteDownloadsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("pages.downloads.application_download.downloadsButton")}
                      </B1Small>
                    </Box>
                  </>
                }
              />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <WidgetMt5TickData />
            </Grid>
          </Grid>
        </Container>
      </Page>
    ) : null;
  }, [isOutletAllowed, t, websiteDownloadsUrl]);
}
